const prettyPrintJson = (json) => JSON.stringify(json, null, 2);

export default prettyPrintJson;
